import React from 'react';
import {Menu, Lines} from '../../assets/icons/icons';
import {TabContainer, TabItem, TabTitle} from './styles';

export default ({
  url,
  dataCy,
  dataArray,
  xmargin = '0px',
  dcolor = '#7C8080',
  textTransform = 'uppercase',
}: {
  url?: string;
  icon?: string;
  dataCy?: string;
  dcolor?: string;
  xmargin?: string;
  dataArray: Array<any>;
  textTransform?: string;
}) => (
  <TabContainer data-cy={dataCy}>
    {dataArray.map((el, idx) => {
      return (
        <TabItem
          onClick={el.action}
          key={idx}
          to={`${url}/${el.url}`}
          xmargin={xmargin}
          dcolor={dcolor}
          texttransform={textTransform}
          activeStyle={{backgroundColor: '#EFF0F2', color: '#5D6E81', fontWeight: 600, borderRadius: '7px'}}
        >
          {el?.icon === 'card' ? (
            <Menu color={window.location.pathname.includes(el.url) ? '#5D6E81' : dcolor} height="20px" width="20px" />
          ) : el?.icon === 'list' ? (
            <Lines color={window.location.pathname.includes(el.url) ? '#5D6E81' : dcolor} height="14px" width="20px" />
          ) : (
            <></>
          )}
          <TabTitle>{el.title}</TabTitle>
        </TabItem>
      )
    })}
  </TabContainer>
);
